<template>
  <div :class="classes()">
    <label :for="name">
      <div :class="`${el}__inputWrapper`">
        <input
          ref="input"
          :class="`${el}__input`"
          :value="value"
          :name="name"
          :placeholder="placeholder"
          :id="name"
          :type="showPassword ? 'text' : type"
          :disabled="disabled"
          :min="min"
          :max="max"
          v-on="{ ...$listeners, input }"
        />

        <fieldset :class="`${el}__fieldset`" aria-hidden="true">
          <legend :class="`${el}__legend`">
            <span v-if="label">{{ label }}</span>
          </legend>
        </fieldset>

        <span v-if="label" :class="`${el}__label`">{{ label }}</span>

        <div :class="`${el}__interactions`">
          <Icon
            v-if="clearable && value.length > 0 && canHaveClearIcon"
            name="close-line"
            :class="`${el}__close`"
            color="secondaryMintDark"
            :onClick="clear"
          />
          <Icon
            v-if="type === 'password'"
            :name="showPassword ? 'eye-off-line' : 'eye-line'"
            :class="`${el}__togglePassword`"
            color="secondaryMintDark"
            :onClick="toggleShowPassword"
          />
          <div v-if="error && !success" :class="`${el}__icon`">
            <Icon name="error-warning-fill" color="supportDanger" />
          </div>
          <div v-if="!error && success" :class="`${el}__icon`">
            <Icon name="checkbox-circle-fill" color="supportSuccess" />
          </div>
        </div>
      </div>
      <Copy
        v-if="error && !success"
        element="div"
        size="s"
        :staticClass="`${el}__helperText`"
        color="supportDanger"
      >
        {{ error }}
      </Copy>
    </label>
  </div>
</template>

<script>
import Icon from '@/objects/Icon';
import Copy from '@/objects/Copy';
export default {
  name: 'BaseInput',
  components: {
    Icon,
    Copy,
  },
  props: {
    label: String,
    name: String,
    value: [String, Number],
    placeholder: String,
    type: {
      type: String,
      default: 'text',
      validator: (val) => ['text', 'email', 'password', 'number'].includes(val),
    },
    error: {
      type: [String, Boolean],
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasMargin: Boolean,
    clearable: Boolean,
    min: Number,
    max: Number,
    onChange: Function,
    onFocus: Function,
    onBlur: Function,
  },
  data() {
    return {
      showPassword: false,
      el: 'o-baseInput',
      isActive: this.value?.length > 0,
      canHaveClearIcon: false,
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          'is-disabled': this.disabled,
          'is-error': Boolean(this.error),
          'is-success': this.success,
          [`${el}--hasMargin`]: this.hasMargin,
          [`${el}--clearable`]: this.clearable,
          [`${el}--active`]: this.isActive,
          [`${el}--password`]: this.type === 'password',
        };
      },
    };
  },

  methods: {
    clear() {
      this.isActive = false;
      this.$emit('input', '');
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
      this.$emit('iconClicked');
    },
    input(event) {
      const { value } = event.target;
      if (value.length === 0) {
        this.canHaveClearIcon = true;
      }
      this.isActive = value.length > 0;
      this.$emit('input', value);
    },
  },
};
</script>
